var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconeCartao = function SvgIconeCartao(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208.003,
    height: 182,
    viewBox: "0 0 208.003 182",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9510",
    "data-name": "Group 9510",
    transform: "translate(-907 -401)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5935",
    "data-name": "Path 5935",
    d: "M203.941,8.69,63.509,88.49a8.791,8.791,0,0,0-3.3,12.111l9.012,15.356,11.258,19.2,29.281,49.91a9.082,9.082,0,0,0,12.3,3.245l140.432-79.8A8.791,8.791,0,0,0,265.8,96.4l-29.281-49.91-11.258-19.2-9.012-15.356A9.082,9.082,0,0,0,203.941,8.69Zm54.049,92.144-140.432,79.8L88.282,130.719l140.432-79.8ZM77.018,111.526,68.012,96.165l140.432-79.8,9.007,15.361Z",
    transform: "translate(848 393.5)",
    fill: "#191750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5936",
    "data-name": "Path 5936",
    d: "M127.263,30.307,72.117,61.642A4.392,4.392,0,0,0,70.468,67.7a4.537,4.537,0,0,0,6.152,1.622l55.146-31.335a4.4,4.4,0,0,0,1.648-6.058A4.543,4.543,0,0,0,127.263,30.307Z",
    transform: "translate(893.62 486.794)",
    fill: "#191750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5937",
    "data-name": "Path 5937",
    d: "M74.939,75.044l74.116-42.115a4.384,4.384,0,0,0,1.648-6.053,4.537,4.537,0,0,0-6.152-1.622L70.436,67.369a4.384,4.384,0,0,0-1.648,6.053A4.533,4.533,0,0,0,74.939,75.044Z",
    transform: "translate(886.562 465.565)",
    fill: "#191750"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconeCartao, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icone_cartao.0ea8e1a6.svg";
export { ForwardRef as ReactComponent };